/* global AWS */
import awsconfig from "@/aws-exports";
/* TS: global AWS del script */
declare const AWS: any;

export class AwsCognitoCredentialsManager {
  private creds: any;
  private sessionInformation: any;

  constructor(store: any) {
    this.sessionInformation =
      store && store.state && store.state.session_information
        ? store.state.session_information
        : null;
  }

  initAWS(): any {
    let idToken: string | null = null;

    if (
      this.sessionInformation &&
      this.sessionInformation.signInUserSession &&
      this.sessionInformation.signInUserSession.idToken &&
      this.sessionInformation.signInUserSession.idToken.jwtToken
    ) {
      idToken = this.sessionInformation.signInUserSession.idToken.jwtToken;
    }
    if (!idToken) return null;

    this.creds = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: awsconfig["aws_cognito_identity_pool_id"],
    });
    this.creds.params.Logins = this.creds.params.Logins || {};
    this.creds.params.Logins[
      "cognito-idp.eu-west-1.amazonaws.com/" + awsconfig["aws_user_pools_id"]
    ] = idToken;
    this.creds.expired = true;

    AWS.config.update({
      region: awsconfig["aws_user_files_s3_bucket_region"],
      credentials: this.creds,
    });
    AWS.config.credentials = this.creds;

    return AWS;
  }

  async ensureAwsCreds(): Promise<any> {
    const needsInit =
      !AWS ||
      !AWS.config ||
      !AWS.config.credentials ||
      AWS.config.credentials.expired;

    if (needsInit) return this.initAWS();
    return AWS;
  }
}
